/*!
 * Link HTML attributes based on a `data-bind` HTML attribute 🥊  tko.provider.databind@4.0.0-alpha5c
 * (c) The Knockout.js Team - https://tko.io/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */

import { BindingStringProvider } from 'tko.provider.bindingstring';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var DataBindProvider = /** @class */ (function (_super) {
    __extends(DataBindProvider, _super);
    function DataBindProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DataBindProvider.prototype, "FOR_NODE_TYPES", {
        get: function () { return [1]; } // document.ELEMENT_NODE
        ,
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataBindProvider.prototype, "BIND_ATTRIBUTE", {
        get: function () {
            return 'data-bind';
        },
        enumerable: true,
        configurable: true
    });
    DataBindProvider.prototype.getBindingString = function (node) {
        if (node.nodeType === document.ELEMENT_NODE) {
            return node.getAttribute(this.BIND_ATTRIBUTE);
        }
    };
    DataBindProvider.prototype.nodeHasBindings = function (node) {
        if (node.nodeType === document.ELEMENT_NODE) {
            return node.hasAttribute(this.BIND_ATTRIBUTE);
        }
    };
    return DataBindProvider;
}(BindingStringProvider));

export { DataBindProvider };
//# sourceMappingURL=tko.provider.databind.js.map
